import { z } from 'zod';
import type { ClaimRequest } from './api';
const schema = z.object({ requestId: z.uuid(), expectedVersion: z.number().int().nonnegative() });
const key = (user: string, id: string) => `geefamily:milestone:${user}:${id}`;
export function readClaim(user: string, id: string): ClaimRequest | null {
  try {
    const value: unknown = JSON.parse(sessionStorage.getItem(key(user, id)) ?? 'null');
    const parsed = schema.safeParse(value);
    return parsed.success ? parsed.data : null;
  } catch {
    return null;
  }
}
export function storeClaim(user: string, id: string, value: ClaimRequest) {
  sessionStorage.setItem(key(user, id), JSON.stringify(value));
}
export function clearClaim(user: string, id: string) {
  try {
    sessionStorage.removeItem(key(user, id));
  } catch {
    /* A replay still returns the original committed claim. */
  }
}
